import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Client, ClientUpsertRequest} from "./model/client";

@Injectable()
export class ClientService {
  constructor(private http: HttpClient) {
  }

  search(query: string, limit: number = 20): Observable<Client[]> {
    let params = new HttpParams().set("limit", limit);
    if (query && query.trim().length > 0) {
      params = params.set("q", query.trim());
    }
    return this.http.get<Client[]>(environment.apiUrl + "/client", {params});
  }

  get(id: string): Observable<Client> {
    return this.http.get<Client>(environment.apiUrl + "/client/" + id);
  }

  create(request: ClientUpsertRequest): Observable<Client> {
    return this.http.post<Client>(environment.apiUrl + "/client", request);
  }

  update(id: string, request: ClientUpsertRequest): Observable<Client> {
    return this.http.put<Client>(environment.apiUrl + "/client/" + id, request);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(environment.apiUrl + "/client/" + id);
  }
}
